<template>
  <div class="page-wrapper chiller-theme" id="main">
    <main-sidebar></main-sidebar>
    <main class="page-content">
      <main-header></main-header>
      <x-store></x-store>
    </main>
  </div>
</template>

<script>
  import MainHeader from '../layout/MainHeader.vue'
  import MainSidebar from '../layout/MainSidebar.vue'
  import XStore from './XStore.vue'

  export default {
    name: 'mobileapps',
    components: {
      MainHeader,
      MainSidebar,
      XStore
    },
    data() {
      return {}
    },
    mounted() {
      this.$store.commit('selectedTab', 'xstore');
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/mobileapps/Index.vue